<dx-popup
    #payeeSelectorPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="60%"
    title="Select a Payee"
    [showCloseButton]="true"
    [shading]="true"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopUpShown()"
    (onHidden)="onPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" class="payee-tab-container" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-tab-panel
                        width="100%"
                        height="100%"
                        class="cc-tab-panel"
                        [dataSource]="payeeTabs"
                        [(selectedItem)]="selectedTabPanel"
                        (onSelectionChanged)="onSelectionChanged()"
                    >
                        <div *dxTemplate="let tabItem of 'title'">
                            <span>{{ tabItem.text }}</span>
                        </div>
                        <div *dxTemplate="let tabItem of 'item'" id="payeeSelector">
                            <div class="tab-panel-content" *ngIf="tabItem.name === 'vendor'">
                                <app-grid-option-selector
                                    *ngIf="tabItem.name === 'vendor'"
                                    [columns]="vendorColumns"
                                    [source]="vendorList"
                                    [keyExpr]="'vendorId'"
                                    (onSelection)="onVendorSelection($event)"
                                ></app-grid-option-selector>
                            </div>
                            <div class="tab-panel-content" *ngIf="tabItem.name === 'owner'">
                                <app-grid-option-selector
                                    *ngIf="tabItem.name === 'owner'"
                                    [columns]="ownerColumns"
                                    [source]="ownerList"
                                    [keyExpr]="'customerId'"
                                    (onSelection)="onOwnerSelection($event)"
                                ></app-grid-option-selector>
                            </div>
                            <div class="tab-panel-content" *ngIf="tabItem.name === 'community'">
                                <app-grid-option-selector
                                    *ngIf="tabItem.name === 'community'"
                                    [columns]="communityColumns"
                                    [source]="communityList"
                                    [keyExpr]="'communityId'"
                                    (onSelection)="onCommunitySelection($event)"
                                ></app-grid-option-selector>
                            </div>
                        </div>
                    </dx-tab-panel>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="left-button-container">
                        <dx-button
                            type="default"
                            text="Close"
                            [icon]="iconClose"
                            (onClick)="onCloseClick()"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#payeeSelector' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
